export default __webpack_public_path__ + "static/favicon-hoox-b462d90d7124a5a921cd98bea28b4589.png";